// material-ui
import { styled, keyframes } from '@mui/material/styles';

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const LoaderWrapper = styled('span')(() => ({
  width: '48px',
  height: '48px',
  border: '3px solid #7a766f',
  borderRadius: '50%',
  display: 'inline-block',
  position: 'relative',
  boxSizing: 'border-box',
  animation: `${rotate} 1s linear infinite`,
  '&::after': {
    content: '""',
    boxSizing: 'border-box',
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: '56px',
    height: '56px',
    borderRadius: '50%',
    border: '3px solid transparent',
    borderBottomColor: '#cf6112'
  }
}));

const Loader = () => {
  return <LoaderWrapper />;
};

export default Loader;
